import { Component, forwardRef } from '@angular/core';
import { OnInit } from '@angular/core';
import { B2BCompanyServices } from 'src/app/backoffice/b2b-companies/b2b-company-services/b2b-company.services';
import { CommonModule } from '@angular/common';
import { B2BCompany } from 'npx-family-happy-common';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'app-b2b-company-select',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './b2b-company-select.component.html',
  styleUrl: './b2b-company-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => B2bCompanySelectComponent),
      multi: true,
    },
  ],
})
export class B2bCompanySelectComponent implements OnInit, ControlValueAccessor {
  companies: B2BCompany[] = [];
  value: B2BCompany | null = null;
  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit(): void {
    // get All Companies
    this.management
      .getAllCompanies(0, 1000, {
        id: null,
        name: null,
        vatNumber: null,
        size: null,
      })
      .subscribe((data) => {
        this.companies = data.content;
      });
  }
  constructor(private management: B2BCompanyServices) {}
  compareCompanies(c1: B2BCompany, c2: B2BCompany): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
